import React, { useContext, useEffect, useState } from "react";
import { Bot, base, loadStatus, startBot, BotStatus, resetBot } from "./bot-loaders";
import { BotResetDialog } from "./bots/BotResetDialog";
import { useModalHide } from "./components/Modal";
import { ProgressBar } from "./components/ProgressBar";
import { logBotEvent } from "./ga/ga-event-logger";
import { Dots, SettingsIcon } from "./guide/icons";
import { PairingCode } from "./pairing-code";
import { BotStore } from "./Store";

export function BotStartModal({bot}:{bot:Bot}){
    const ctx = useContext(BotStore);
    const [b, setB] = useState(bot);
    const [qrTag, setQrTag] = useState(1);
    const hide = useModalHide();

    async function checkStatus(){
        var bot = await loadStatus(b);
        if(bot.status == 'online')
            await hide();
        setB(bot);
        ctx.dispatch({type: "updateBot", payload: bot});
    }

    async function start(){
        logBotEvent(b, 'start');
        startBot(b);
        setB({...b, status: "initializing"});
    }

    useEffect(function(){
        const handle = setInterval(checkStatus, 3000);
        return () => clearInterval(handle);
       
    }, []);

    useEffect(() =>{
        setQrTag(Math.round(new Date().getTime()))
    }, [bot.qrcode, bot.id])

    if(b.status == 'qrcode' && !b.loadedProgress)
        return <>
            <h3>Conectando seu número de WhatsApp</h3>
            <ol>
                <li>Abra o WhatsApp no seu celular.</li>
                <li>Toque em Mais opções <Dots />  ou Configurações <SettingsIcon /> e selecione Aparelhos conectados.</li>
                <li>Toque em Conectar um aparelho.</li>
                <li>Aponte seu celular para esta tela para capturar o QR code.</li>
            </ol>
            <img className="d-block mt-3" style={{margin: "auto"}} src={`${base}bots/${bot.id}/qrcode.png?${qrTag}`} />
            <PairingCode bot={bot} />
            <StuckBotAlert key={'q'} bot={b} atStart={true}/>
        </>

    if((b.status == 'qrcode' || b.status == 'initializing') && b.loadedProgress !== undefined)
        return <>
            <ProgressBar done={b.loadedProgress} total={100} />
            <StuckBotAlert bot={b} />
        </>

    if(b.status == 'idle' || b.status == 'offline'){
        return <>
            <div className="text-center"><button className="btn btn-primary" onClick={start}>Conectar ao WhatsApp</button></div>
            <div className="mb-3"></div>
        </>
    }

    return <>{BotStatus[b.status]}...<StuckBotAlert key={'s'} bot={b} atStart={true}/></>
    
}

function StuckBotAlert({bot, atStart = false}:{bot: Bot, atStart?:boolean}){
    const {dispatch} = useContext(BotStore);
    const [showButton, setShowButton] = useState(false);

    useEffect(function(){
        if(!atStart && bot.loadedProgress != 100) return;
        var timer = setTimeout(()=>setShowButton(true), atStart ? 90000 : 30000);
        return ()=>{
            clearTimeout(timer)
        }
    }, [bot.id, bot.loadedProgress])

    function onReset(newBot:Bot){
        dispatch({type:"updateBot", payload: newBot})
    }

    if(showButton)
        return <BotResetDialog onAction={onReset} bot={bot} showMessage={true} />
    
    return null;    
}